import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { Datepicker } from '../Datepicker';

export type DateRangePickerProps = {
  startName: string;
  endName: string;
  labelOut?: boolean;
  startLabel?: string;
  endLabel?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formContext: UseFormReturn<any>;
};

export function DateRangePicker({
  startName,
  endName,
  labelOut,
  startLabel,
  endLabel,
  formContext,
}: DateRangePickerProps) {
  return (
    <div className="flex flex-row space-x-4">
      <FormProvider {...formContext}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          <Datepicker
            label={startLabel || 'Início'}
            name={startName}
            labelOut={labelOut || false}
          />
          <Datepicker
            label={endLabel || 'Fim'}
            name={endName}
            labelOut={labelOut || false}
          />
        </LocalizationProvider>
      </FormProvider>
    </div>
  );
}
